<div class="form-container font-title">
    <div *ngIf="log" class="note-container">
        <img class="login-note-logo" src="../../assets/Logo/svg/Logo_8.svg">
        <br><br>
        <span [innerHTML]="'login.text1' | translate"></span>
    </div>
    <div *ngIf="log" class="login-container">
        <div class="lang-button-container">
            <button id="lang-switcher" class="lang-button" (click)="switchLang()">{{('langName.' + language) | translate }}</button>
        </div>
        <h3>{{ 'login.text2' | translate }}</h3>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmitLogin(loginForm.value)">
            <input class="form-control col-sm-7" type="text" [placeholder]="'login.placeholder.text1' | translate" formControlName="loginUsername">
            <br>
            <input class="form-control col-sm-7" type="password" [placeholder]="'login.placeholder.text2' | translate" formControlName="password">
            <br>
            <input class="btn btn-success col-sm-7" type="submit" value="{{'login.value.text1' | translate}}">
        </form>
        <br>
        <a class="col-sm-1 col-md-2 col-lg-2" id="forgot-password-link" (click)="goToForgotPasswordPage()">{{ 'login.text3' | translate }}</a>
        <br>
        <br>
        <br>
        <br>
        <br>
        <span>{{ 'login.text4' | translate }}</span>
        <a class="col-sm-1 col-md-2 col-lg-2" (click)="log = false; getRegisteredUsernames()" href="#">{{ 'login.text5' | translate }}</a>
    </div>

    <div *ngIf="!log" class="note-container">
        <img  class="register-note-logo" src="../../assets/Logo/svg/Logo_8.svg">
        <br><br>
        <span [innerHTML]="'login.text1' | translate"></span>
    </div>
    <div *ngIf="!log" class="register-container">
        
        <div class="lang-button-container">
            <button id="lang-switcher" class="lang-button" (click)="switchLang()">{{('langName.' + language) | translate }}</button>
        </div>
        
        <h3>{{ 'login.text6' | translate }}</h3>

        <!-- <form [formGroup]="regForm" (ngSubmit)="onSubmitReg(regForm.value)"> -->
        <form [formGroup]="regForm" (ngSubmit)="onSubmitReg(regForm)">
            <input class="form-control col-sm-7" type="text" [placeholder]="'login.placeholder.text8' | translate" formControlName="firstName">
            <span *ngIf="reg.firstName.touched && reg.firstName.errors?.required"
            class="help-block alert-danger">{{ 'login.text27' | translate }}</span>
            <br>
            <input class="form-control col-sm-7" type="text" [placeholder]="'login.placeholder.text9' | translate" formControlName="lastName">
            <span *ngIf="reg.lastName.touched && reg.lastName.errors?.required"
            class="help-block alert-danger">{{ 'login.text28' | translate }}</span>
            <br>
            <input class="form-control col-sm-7" type="text" [placeholder]="'login.placeholder.text1' | translate" formControlName="username">
            <!-- [errorStateMatcher]="duplicateUsernameMatcher(registeredUsernames, reg.username.value)" -->
            <span *ngIf="reg.username.touched && reg.username.errors?.required"
            class="help-block alert-danger">{{ 'login.text7' | translate }}</span>
            <span *ngIf="reg.username.errors?.duplicate"
            class="help-block alert-danger">{{ 'login.text8' | translate }}</span>
            <!-- reg.username.touched &&  -->
            <br>
            <input class="form-control col-sm-7" type="email" [placeholder]="'login.placeholder.text3' | translate" formControlName="email" />
            <span *ngIf="reg.email.touched && reg.email.errors?.required"
            class="help-block alert-danger">{{ 'login.text9' | translate }}</span>
            <span *ngIf="reg.email.touched && reg.email.errors?.email"
            class="help-block alert-danger">{{ 'login.text10' | translate }}</span>
            <br>
            <input class="form-control col-sm-7" type="password" [placeholder]="'login.placeholder.text2' | translate" formControlName="password">
            <span *ngIf="reg.password.touched && reg.password.errors?.required"
            class="help-block alert-danger">{{ 'login.text11' | translate }}</span>
            <br>
            <input class="form-control col-sm-7" type="password" [placeholder]="'login.placeholder.text4' | translate" formControlName="password2">
            <span *ngIf="reg.password2.touched && reg.password2.errors?.required"
            class="help-block alert-danger">{{ 'login.text12' | translate }}</span>
            <span
            *ngIf="reg.password2.errors?.notMatching"
            class="help-block alert-danger">{{ 'login.text13' | translate }}</span>
            <br>
            <select class="form-control col-sm-7" type="text" [placeholder]="'login.placeholder.text5' | translate" name="userType" formControlName="userType" >
                <!-- [(ngModel)]="userType" -->
                <option value="" selected disabled hidden>{{ 'login.text14' | translate }}</option>
                <option [ngValue]="null" [disabled]="true" >{{ 'login.text15' | translate }}</option>
                <option value="student">{{ 'login.text16' | translate }}</option>
                <option value="teacher">{{ 'login.text17' | translate }}</option>
            </select>
            <br>
            <select class="form-control col-sm-7" type="text" [placeholder]="'login.placeholder.text6' | translate" name="gender" formControlName="gender" >
                <!-- [(ngModel)]="userType" -->
                <option value="" selected disabled hidden>{{ 'login.text18' | translate }}</option>
                <option [ngValue]="null" [disabled]="true" >{{ 'login.text19' | translate }}</option>
                <option value="male">{{ 'login.text20' | translate }}</option>
                <option value="female">{{ 'login.text21' | translate }}</option>
            </select>
            <br>
            <select class="form-control col-sm-7" type="text" [placeholder]="'login.placeholder.text7' | translate" name="avatarType" formControlName="avatarType" >
                <!-- [(ngModel)]="userType" -->
                <option value="" selected disabled hidden>{{ 'login.text22' | translate }}</option>
                <option [ngValue]="null" [disabled]="true" >{{ 'login.text23' | translate }}</option>
                <option value="HUMAN">{{ 'login.text24' | translate }}</option>
                <option value="ROBOT">{{ 'login.text25' | translate }}</option>
            </select>
            <br>
            <input class="btn btn-success col-sm-7" type="submit" value="{{'login.value.text2' | translate}}" [disabled]="regForm.invalid"/>
        </form>
        <br>
        <a class="col-sm-1 col-md-2 col-lg-2" (click)="log = true;" href="#">{{ 'login.text26' | translate }}</a>
        <!-- <button class="btn btn-info purple-btn" (click)="log= true;">Go to Sign in page</button> -->
    </div>
</div>
